<template>
  <div class="mini-calendar__pool" v-if="categorylist.keys ? true : false">
    <div class="mini-calendar__pool-filters">
      <span aria-hidden="false" class="mini-calendar__pool-filters__item" v-show="search" @click="onClear"><IconClose/> Searching By: {{search}}</span>
      <span aria-hidden="false" class="mini-calendar__pool-filters__item" v-show="date_range.type != ''" @click="onClearDate"><IconClose/> Date: {{getDateFilterName}}</span>

      <span v-show="search == ''" class="mini-calendar__pool-filters__item" @click="onRemoveFilter(item)" v-for="item in filter" :key="item"><IconClose/> {{getCategoryName(item)}}</span>

    </div>
    <div class="mini-calendar__pool-result" v-show="total >= 0">
      Showing <b>{{eventlist.length}}</b> of <b>{{total}}</b> events
    </div>

    <div class="mini-calendar__pool-clear">
      <span class="mini-calendar__pool-filters__item" @click="onClearAll()" v-if="search != ''"><IconClose/>Clear Search</span>
      <span class="mini-calendar__pool-filters__item" @click="onClearAll()" v-if="filter.length != 0 || date_range.type != ''"><IconClose/>Clear Filter</span>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import { getEvents, getFilteredEvents } from './../api'
import IconClose from './icon/icon-close.vue'
import { DATE_FILTER, DATE_SHOW_FORMAT } from "@/utils/config";
import { generateDatefromFilter } from "@/utils/util";
import { RouterPath } from '@/utils/mixin'
import moment from 'moment'

export default {
  name: 'MiniCalenderPool',
  components: {
    IconClose
  },
  mixins: [RouterPath],
  methods: {
    getCategoryName(filter) {
      for (let key of this.categorylist.keys) {
        let filtered = this.categorylist.data[key].terms.find((item) => item.id == filter);
        if (filtered) {
          return this.categorylist.data[key].title + ': ' + filtered.name
        }
      }

      return '';
    },
    onClearAll() {
      this.onClear();
      this.setFilter([]);
      this.$router.push("/");
    },
    onClear() {

      this.setLoading(true);
      getEvents().then((eventlist) => {
        this.setClearAll();
        this.setEventList({eventlist: eventlist.data, total: eventlist.query.total})
        this.setLoading(false);
      }).catch(() => {
        this.setLoading(false);
      });
    },
    onClearDate() {
      this.setLoading(true);
      getFilteredEvents('', '', this.filter).then((response) => {
          this.setDateRange({
            type: '',
            start: '',
            end: ''
          });
          if (response) {

              let data = response.data ? response.data : [];

              this.setEventList({eventlist: data, total: response.query.total})
          }

          this.setLoading(false);
      }).catch(() => {
          this.setLoading(false);
      });
    },
    onRemoveFilter(item) {
      const filtered = this.filter.filter((f) => item != f);
      this.setLoading(true);
      getFilteredEvents(this.date_range.start, this.date_range.end, filtered).then((response) => {
          this.setFilter(filtered);
          this.pushurl(filtered);

          if (response) {

              let data = response.data ? response.data : [];

              this.setEventList({eventlist: data, total: response.query.total})
          }

          this.setLoading(false);
      }).catch(() => {
          this.setLoading(false);
      });
    },
    ...mapActions(['setEventList', 'setSearch', 'setClearAll', 'setLoading', 'setFilter', 'setDateRange'])
  },
  computed: {
    getDateFilterName() {
      if (this.date_range.type == 'custom_range') {
        if (!this.date_range.start) {
          return '';
        } else if (this.date_range.start == this.date_range.end) {
          return moment(this.date_range.start).format(DATE_SHOW_FORMAT);
        } else {
          return moment(this.date_range.start).format(DATE_SHOW_FORMAT) + ' to '+ moment(this.date_range.end).format(DATE_SHOW_FORMAT);
        }

      }

      let item = DATE_FILTER.list.find((item) => item.id== this.date_range.type);
      if (item) {
        return generateDatefromFilter(item.id);
      }

      return ''
    },
    ...mapGetters(['total', 'eventlist', 'search', 'date_range', 'filter', 'categorylist'])
  }
}
</script>
<style lang="scss">
.mini-calendar__pool {
  font-size: rem(16);
  padding: rem(10) 0 rem(20);

  &-clear {
    display: flex;
    justify-content: flex-end;
    padding: rem(20) 0 0;
  }

  &-filters {
    display: flex;
    flex-wrap: wrap;
    gap: rem(10);

    &__item {
      margin-bottom: rem(10);
      color: $text-color1;
      display: flex;
      cursor: pointer;
      align-items: center;
      gap: 5px;

      svg {
        width: 16px;

        path {
          fill: $text-color1;
        }
      }

      &:hover {
        color: $alert-color;

        path {
          fill: $alert-color;
        }
      }
    }
  }

  &-result {
    color: $text-color;
  }
}
</style>